import { graphql, useStaticQuery } from 'gatsby';
export const useProducts = () => useStaticQuery(graphql `
      query useProductsQuery {
        cosmos {
          collections {
            products {
              product_name
              product_description
              product_link
              product_logo {
                ticket
                fileName
              }
              brand_colour
            }
          }
        }
      }
    `).cosmos.collections;
export default useProducts;
